import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { debug } from "debug";
import { StoreCommon } from "~/types/index";
import { retrieveLaunchParams } from "@telegram-apps/sdk-react";
import { getTimeZone } from "../utils/common";
import { debounce } from "~/tools/common";
import events, { EVENTS_NAMES } from "~/tools/eventBus";
import { config } from "~/config";
import { tgLink } from "~/utils";

// https://github.com/Telegram-Mini-Apps/tma.js/blob/7d5daf392b0763702516f8fd8169305bc201415c/apps/docs/platform/authorizing-user.md

const isDev = process.env.NODE_ENV == "development";
const baseURL = config.api.endpoint;
const AUTH_KEY = "__uxuy_dex_cached_authorization_info__";

console.log("baseURL....", baseURL);

export type RequestHeader =
    | AxiosRequestHeaders
    | {
          isThrottle?: boolean;
          throttleTime?: number;

          isCached?: boolean;
          CacheTime?: number;

          isUpdate?: boolean;
          UpdateTime?: number;
      };

// 使用 Omit 工具类型移除 headers 属性
export type httpAxiosRequestConfig = Omit<AxiosRequestConfig, "headers">;

export interface response {
    code: number;
    data: any;
}

const logger = debug("uxuy:dex");

const service = axios.create({
    baseURL: baseURL + "/tgdex_gw/v1/",
    timeout: 60 * 1000,
});

function getHeaders() {
    const basicHeaders = {
        "x-user-language": "en",
        "x-web-timezone": getTimeZone(),
        // 'X-CSRF-Token': document?.documentElement?.dataset?.class || document.querySelector('html')?.dataset?.class,
        "Content-Type": "application/json",
    };

    try {
        const { initData } = retrieveLaunchParams();
        const authorization = sessionStorage.getItem(AUTH_KEY);

        const headers = Object.assign({}, basicHeaders, {
            "x-user-language": initData?.user?.languageCode ?? "en",
        });

        if (authorization == null || authorization.length === 0) {
            return headers;
        }

        return Object.assign({}, headers, {
            Authorization: `Bearer ${authorization}`,
        });
    } catch {
        return basicHeaders;
    }
}

let doLoginPromise: Promise<StoreCommon.CommonState["user"]> | null = null;
export function doLogin() {
    if (doLoginPromise) {
        return doLoginPromise;
    }

    try {
        const { initDataRaw, startParam } = retrieveLaunchParams();
        const data = tgLink.parseLink(startParam);
        const thAuthorizationData = isDev
            ? import.meta.env.VITE_TG_AUTHORIZATION
            : initDataRaw;

        logger("Telegram Launch Params", thAuthorizationData);

        doLoginPromise = axios
            .post(
                baseURL + "/tgdex_gw/v1/login",
                {
                    auth_data: thAuthorizationData,
                    invite_code: data?.params?.invite_code,
                    channel: data?.params?.invite_source,
                    chain_id: data?.params?.chain_id,
                    contract: data?.params?.contract,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then((res) => {
                logger("RES", res);
                const user = res.data;
                const auth_token = res?.data?.session_token || "";
                sessionStorage.setItem(AUTH_KEY, auth_token)
                return user;
            })
            .catch((err) => {
                Promise.reject("Login Failed " + err);
            });

        return doLoginPromise;
    } catch (err) {
        doLoginPromise = Promise.reject("Login Failed " + err);
        return doLoginPromise;
    }
}

const ON_SESSION_EXPIRED = debounce(() => {
    events.emit(EVENTS_NAMES.SESSION_EXPIRED);
}, 500);

service.interceptors.request.use(
    async (config) => {
        const authorization = sessionStorage.getItem(AUTH_KEY);
        if (authorization == null || authorization.length === 0) {
            doLoginPromise = null;
            await doLogin();
        }

        const headers = getHeaders();
        Object.entries(headers).forEach((header) => {
            const [key, value] = header;
            config.headers.set(key, value, true);
        });
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

//响应拦截
service.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error(error);
        const code = error?.response?.data?.code || error?.code;
        if (code === 401) {
            ON_SESSION_EXPIRED();
        } else if (code === 402) {
            doLoginPromise = null;
            return doLogin().then(() => service(error.config));
        }
        const message = error?.response?.data?.message || error?.message;
        return Promise.reject({ code: code, message: message });
    }
);

const http = {
    get: <T = any>(url: string) => {
        return service.get<T>(url);
    },
    post: <T = any>(url: string, data: any, config?: AxiosRequestConfig) => {
        return service.post<T>(url, data, config);
    },
};

export default http;
